import axiosClient from './axiosClient';
import { UserActivity } from '../types';

// --- User Activity API Calls ---

export const logUserActivityApi = async ({ uid, activityData }: { uid: string; activityData: Omit<UserActivity, "id"> }): Promise<string> => {
  try {
    const response = await axiosClient.post(`/users/${uid}/activities`, activityData);
    return response.data.id;
  } catch (error) {
    console.error("Error logging user activity:", error);
    throw error;
  }
};

export const fetchUserActivitiesApi = async (uid: string): Promise<UserActivity[]> => {
  try {
    const response = await axiosClient.get(`/users/${uid}/activities`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user activities:", error);
    throw error;
  }
};

export const getActivities = async (): Promise<UserActivity[]> => {
  try {
    const response = await axiosClient.get('/activities');
    return response.data;
  } catch (error) {
    console.error("Error fetching all activities:", error);
    throw error;
  }
};

/** One bucket of the activity trend: a calendar day and how much happened. */
export interface ActivityDailyPoint {
  date: string;
  count: number;
}

export interface ActivityStats {
  days: number;
  since: string;
  total: number;
  today: number;
  activeUsers: number;
  byType: Array<{ type: string; count: number }>;
  /** Zero-filled across the window, so a quiet day is drawn as the zero it is. */
  daily: ActivityDailyPoint[];
}

export const getActivityStats = async (days: number = 30): Promise<ActivityStats> => {
  const response = await axiosClient.get('/activities/stats', { params: { days } });
  return response.data;
};
